<template>
  <div class="loader-holder">
    <LoadingSpinner size="68px"></LoadingSpinner>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';
export default {
  components: {
    LoadingSpinner
  }
};
</script>

<style scoped>
.loader-holder {
  overflow: hidden;
  padding: 80px 0;
}
</style>
